import { isMobile } from "..";
import { BASE_URL } from "../url";

export const bannoTenants = {
    banno: "banno",
    tinker: "tinker"
};

export const isBannoTenant = (props, fromProps = true) => {
    if (!fromProps) {
        return Object.values(bannoTenants).includes(props);
    }
    return Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName);
}

export const loadBannoBridge=(tenant)=> {

    if (!isBannoTenant(tenant, false)) {
        return;
    }

    const url = "https://cdn.jsdelivr.net/npm/@jack-henry/banno-plugin-framework-bridge@1.0.3/dist/banno-plugin-framework-bridge.js";

    // if already loaded, resolve immediately
    if (window && window.Bridge) {
        return Promise.resolve(window.Bridge);
    }
    // avoid loading multiple times: reuse existing promise
    if (window && window._bannoBridgeLoading) {
        return window._bannoBridgeLoading;
    }

    // dynamic import of an external module URL (must be supported by the browser)
    const promise = import(/* webpackIgnore: true */ url)
        .then(mod => {
            // store globally for other parts of the app
            window.Bridge = mod;
            if (typeof mod.enableRouter === "function") {
                try {
                    mod.enableRouter();
                    console.log("Banno router enabled (from dynamic loader).");
                } catch (err) {
                    console.warn("Banno bridge loaded but enableRouter() threw:", err);
                }
            } else {
                console.warn("Banno bridge loaded but enableRouter() not found.");
            }
            return mod;
        })
        .catch(err => {
            console.error("Failed to load Banno bridge:", err);
            // cleanup so future attempts can retry
            delete window._bannoBridgeLoading;
            throw err;
        });

    // cache the promise
    window._bannoBridgeLoading = promise;
    return promise;
}


export const hideEnrollmentBannoTenants = (props) => {
    if (Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName) && window.parent.banno) {
        window.parent.banno.enrollment.ishow = false;
        window.parent.banno.updateEnroll(true);
    }
}

export const showEnrollmentBannoTenants = (props) => {
    if (Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName) && window.parent.banno) {
        window.parent.banno.enrollment.ishow = true;
        window.parent.banno.updateEnroll(false);
    }
}

export const updateTokenBannoTenants = (props, token) => {
    if (Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName) && window.parent.banno) {
        window.parent.banno.updateToken(token);
    }
}

export const launchBannoIFrame = (props) => {
    if (Object.values(bannoTenants).includes(props?.state?.theme?.values?.tenantFullName)) {
        const url = `${BASE_URL.API}/integrations/banno/status/step-one/${props?.state?.theme?.values?.tenantFullName}?type=dashboard`;
        return url;
    }
}